import { LensScriptFlag, LensScriptView } from "generated/graphql";
import { exists } from "helpers/coll";

export const ALL_LENS_SCRIPT_FLAGS: { name: string; value: LensScriptFlag }[] = Object.entries(LensScriptFlag).map(
  ([name, value]) => ({
    name: name,
    value: value,
  })
);

export const ALL_LENS_SCRIPT_FLAGS_VALUES: LensScriptFlag[] = ALL_LENS_SCRIPT_FLAGS.map((f) => f.value);

export function displayLensScriptFlag(flag: LensScriptFlag): string {
  switch (flag) {
    case LensScriptFlag.Auto:
      return "Auto";
    case LensScriptFlag.RequireCalcs:
      return "Require Calcs";
    case LensScriptFlag.RequireDocs:
      return "Require Docs";
    case LensScriptFlag.RequireReferences:
      return "Require References";
  }
}

export function scriptHasFlag(script: LensScriptView | undefined, flag: LensScriptFlag): boolean {
  return exists(script?.flags ?? [], (f) => f === flag);
}
